import React from "react"
import { values, sortBy } from "lodash"
import { connect } from "react-redux"
import { push } from "connected-react-router"

import {cities} from "../../../../data"
import "./CitySelector.less"

const citiesList = sortBy(values(cities), "zsxOrder")
// const head = citiesList[0]
// const tail = citiesList.slice(1)

const CitySelector = ({ goto }) => (
  <div className="CitySelector">
    <div className="cities">
      {
        citiesList
          .map(city => (
            <button 
              key={city._id} 
              className="city"
              style={{ 
                backgroundImage: (
                  "linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)),"
                    + `url(${city.background})`
                ),
                backgroundPosition: city.backgroundPosition
              }}
              onClick={() => { goto(`/catalogo/${city.key}/citypage/`) }}
            >
              <p>{city.chinese}</p>
              <p>{city.name}</p>
            </button>
          ))
      }
    </div>
  </div>
)

const mapStateToProps = (_state, _ownProps) => ({})

const mapDispatchToProps = dispatch => ({
  goto: (url) => dispatch(push(url)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CitySelector)



// WEBPACK FOOTER //
// ./src/app/catalogo/components/CitySelector.jsx